import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function Counters() {
  const [counters, setCounters] = useState([]);
  const [newCounter, setNewCounter] = useState("");

  // Fetch counters on mount
  useEffect(() => {
    fetchCounters();
  }, []);

  const fetchCounters = async () => {
    try {
      const response = await axios.get(`${domain()}?endpoint=counters`);
      setCounters(response.data);
    } catch (error) {
      console.error("Error fetching counters:", error);
    }
  };

  const handleAddCounter = async () => {
    if (newCounter.trim()) {
      try {
        const formData = new FormData();
        formData.append("name", newCounter);

        await axios.post(`${domain()}?endpoint=counters`, formData);
        setNewCounter("");
        fetchCounters();
      } catch (error) {
        console.error("Error adding counter:", error);
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${domain()}?endpoint=counters&id=${id}`);
      fetchCounters();
    } catch (error) {
      console.error("Error deleting counter:", error);
    }
  };

  const handleEdit = (index) => {
    const updatedCounters = counters.map((c, i) =>
      i === index ? { ...c, isEditing: !c.isEditing } : c
    );
    setCounters(updatedCounters);
  };

  const handleSave = async (id, name) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("_method", "PUT");

      await axios.post(`${domain()}?endpoint=counters&id=${id}&_method=PUT`, formData);
      fetchCounters();
    } catch (error) {
      console.error("Error updating counter:", error);
    }
  };

  const handleInputChange = (index, value) => {
    const updatedCounters = counters.map((c, i) =>
      i === index ? { ...c, name: value } : c
    );
    setCounters(updatedCounters);
  };

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Counters</h5>
      <div className="d-flex mb-2">
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Counter name"
          value={newCounter}
          onChange={(e) => setNewCounter(e.target.value)}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddCounter}>
          Add
        </button>
      </div>
      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Counter Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {counters.length > 0 ? (
            counters.map((c, index) => (
              <tr key={c.id}>
                <td>{index + 1}</td>
                <td>
                  {c.isEditing ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={c.name}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                    />
                  ) : (
                    c.name
                  )}
                </td>
                <td>
                  {c.isEditing ? (
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => handleSave(c.id, c.name)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(c.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-muted">
                No counters found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Counters;
